export default __webpack_public_path__ + "assets/6df2b01bd989d951df47cb7c2ef7f35e.svg";